import Grid from "@mui/material/Unstable_Grid2/Grid2";
import FormSectionGrid from "../Form/FormSectionGrid";
import FormSectionHeader from "../Form/FormSectionHeader";
import LabelValue from "./LabelValue";

const ThirdPartyInvoice = ({
  pageText,
  candidateDetails,
}: {
  pageText: any;
  candidateDetails: any;
}) => {
  return (
    <>
      <FormSectionHeader>
        {pageText?.labelsMetadata.thirdpartysection}
      </FormSectionHeader>
      <FormSectionGrid>
        <Grid xs={12} sm={6}>
          <LabelValue
            label={pageText?.labelsMetadata.enableThirdPartyInvoiceLabel}
            value={candidateDetails?.enableThirdParty?.label}
          />
        </Grid>

        {candidateDetails?.enableThirdParty?.value === "1" && (
          <>
            <Grid xs={12} sm={6}>
              <LabelValue
                label={pageText?.labelsMetadata.isThirdPartyACompanyLable}
                value={candidateDetails?.isThirdPartyCompany?.label}
              />
            </Grid>
            {candidateDetails?.fiscalNumber && (
              <Grid xs={12} sm={6}>
                <LabelValue
                  label={
                    pageText?.labelsMetadata.fiscalIdentificationNumberLabel
                  }
                  value={candidateDetails?.fiscalNumber}
                />
              </Grid>
            )}
            <Grid xs={12} sm={candidateDetails?.fiscalNumber ? 6 : 12}>
              <LabelValue
                label={pageText?.labelsMetadata.nameOfPayeeOrCompanyLabel}
                value={candidateDetails?.payeeName}
              />
            </Grid>
            <Grid xs={12} sm={6}>
              <LabelValue
                label={pageText?.labelsMetadata.addressOrCompanyAddressLabel}
                value={candidateDetails?.thirdPartyAddress}
              />
            </Grid>
            <Grid xs={12} sm={6}>
              <LabelValue
                label={pageText?.labelsMetadata.postcodeLabel}
                value={candidateDetails?.thirdPartyPostCode}
              />
            </Grid>
            <Grid xs={12} sm={6}>
              <LabelValue
                label={pageText?.labelsMetadata.cityLabel}
                value={candidateDetails?.thirdPartyCity}
              />
            </Grid>
            <Grid xs={12} sm={6}>
              <LabelValue
                label={pageText?.labelsMetadata.countryLabel}
                value={candidateDetails?.thirdPartyCountry.label}
              />
            </Grid>
          </>
        )}
      </FormSectionGrid>
    </>
  );
};

export default ThirdPartyInvoice;
